module.exports = __webpack_public_path__ + "img/horizontal_7_7_7042.8abf2c93.png";